<template>
    <div>
        <!-- <router-link to="/logmonitoring/addMonitoringForm"><base-button type="info" class="addIndicatorBtn"
            >Add Indicators</base-button
        ></router-link>
         -->
        <!-- <router-link to="/logmonitoring/indicatorForm" ><base-button
            type="info"
            class="addIndicatorBtn"
            >Indicator Form</base-button
        ></router-link> -->
        <!-- Modal -->
        <modal
            class="modal alert"
            v-if="showAlert"
            :show.sync="showAlert"
            headerClasses="justify-content-center"
            >Are you sure to delete this indicator?<br />
            <base-button
                @click="deleteApplicationIndicator()"
                class="alert__button"
                >Yes</base-button
            >
            <base-button
                @click="showAlert = false"
                type="warning"
                class="alert__button"
                >No</base-button
            ></modal
        >
        <modal
            class="modal"
            v-if="showForm"
            :show.sync="showForm"
            headerClasses="justify-content-center"
        >
            <div>
                <base-pagination></base-pagination>
            </div>
            <h3 v-if="!isUpdate">Add Indicator</h3>

            <el-form
                ref="form"
                :model="form"
                label-width="120px"
                v-if="showForm"
                class="form"
                style="
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: flex-start;
                    padding: 0px;
                "
            >
                <!-- <div class="select input">
                    Indicator Type :
                    <el-select
                        v-model="customIndicatorForm.indicator_type"
                        placeholder="Select Indicator Type"
                        class="select__field"
                    >
                        <el-option
                            v-for="item in indicatorTypes"
                            :key="item.id"
                            :label="item.type"
                            :value="item.id"
                        >
                        </el-option>
                    </el-select>
                </div> -->
                <div
                    style="
                        display: flex;
                        flex-wrap: nowrap;
                        flex-direction: row;
                    "
                >
                    <div class="input">
                        Indicator ID :
                        <el-input
                            v-model="customIndicatorForm.indicator_id"
                            placeholder="Indicator ID"
                            class="input__field"
                        ></el-input>
                    </div>
                    <div class="input">
                        Indicator Name :
                        <el-input
                            v-model="customIndicatorForm.indicator_name"
                            placeholder="Indicator Name"
                            class="input__field"
                        ></el-input>
                    </div>
                </div>
                <div
                    style="
                        display: flex;
                        flex-wrap: nowrap;
                        flex-direction: row;
                    "
                >
                    <div class="input" style="width: 500px">
                        Metric :
                        <el-input
                            v-model="customIndicatorForm.metric"
                            placeholder="Metric"
                            class="input__field"
                            style="width: 434px !important"
                        ></el-input>
                        <div
                            style="
                                color: lightslategray;
                                margin-left: 10px;
                                max-width: 500px;
                            "
                        >
                            If several metrics are to be entered, please use a
                            comma to separate them.
                        </div>
                    </div>
                    <!-- <div class="input">
                        Description :
                        <el-input
                            type="textarea"
                            :autosize="{ minRows: 3, maxRows: 5 }"
                            placeholder="Description"
                            v-model="customIndicatorForm.description"
                        >
                        </el-input>
                    </div> -->
                </div>
            </el-form>
            <!-- <div class="errorAlert">{{ baseAlertText }}</div> -->
            <div class="errorAlert">{{ baseAlertCustomText }}</div>
            <base-button @click="addIndicator()">Submit</base-button>
        </modal>
        <!-- Not Modal -->
        <!-- <h3>Add Indicator</h3> -->
        <!-- <h3 v-if="isUpdate">Update Indicator</h3> -->
        <el-form ref="form" :model="form" label-width="120px" class="form">
            <!-- <div class="input">
                Grant :
                <el-select
                    v-model="form.Grant_ID"
                    placeholder="Select Grant"
                    class="select__field"
                >
                    <el-option
                        v-for="item in grantsList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                    >
                    </el-option>
                </el-select>
            </div> -->
            <div class="input">
                Applications :
                <el-select
                    v-model="form.Application"
                    placeholder="Select Application"
                    class="select__field"
                    :disabled="disabledForm.applications"
                >
                    <el-option
                        v-for="item in applicationsList"
                        :key="item.id"
                        :label="item.reference"
                        :value="item.id"
                    >
                    </el-option>
                </el-select>
            </div>
            <div class="input">
                Region :
                <el-input
                    v-model="form.Region"
                    placeholder="Region"
                    class="input__field"
                    disabled
                ></el-input>
            </div>

            <div class="input">
                OCTS :
                <el-select
                    v-model="form.Country"
                    placeholder="Select OCTS"
                    class="select__field filter-select mr-2"
                    clearable
                    disabled
                >
                    <!-- :disabled="disabledForm.applications" -->
                    <el-option
                        v-for="item in countriesList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                    >
                    </el-option>
                </el-select>
            </div>
            <!-- <div class="input">
                Country :
                <el-input
                    v-model="form.Country"
                    placeholder="Country"
                    class="input__field"
                    disabled
                ></el-input>
            </div> -->
            <!-- <div class="input">
                WDPAID :
                <el-input
                    v-model="form.WDPaid"
                    placeholder="WDPAID"
                    class="input__field"
                ></el-input>
            </div> -->
        </el-form>
        <!-- {{indicatorsList}} -->
        <!-- <br/> -->
        <!-- {{tableData}} -->
        <div class="indicatorsform">
            <div class="indicatorsform__add">
                <el-form
                    ref="form"
                    :model="form"
                    label-width="120px"
                    class="form2"
                >
                    <!-- {{ indicatorsList }} -->
                    <table>
                        <tr>
                            <td>
                                <div class="input">
                                    Indicators :
                                    <el-autocomplete
                                        class="inline-input"
                                        v-model="selectedIndicator"
                                        :fetch-suggestions="querySearch"
                                        placeholder="Select Indicator"
                                        @select="handleSelect"
                                        popper-class="my-autocomplete"
                                        clearable
                                        :disabled="
                                            disabledForm.indicators || isUpdate
                                        "
                                    >
                                        <template slot-scope="{ item }">
                                            <div class="value">
                                                {{ item.indicatorCode }}
                                                &nbsp; - &nbsp;
                                                <span class="link">{{
                                                    item.indicator
                                                }}</span>
                                            </div>
                                        </template>
                                    </el-autocomplete>
                                </div>
                            </td>
                            <!-- <td>
                                <div class="input">
                                    Indicators :
                                    <el-select
                                        v-model="indicatorForm.indicator"
                                        placeholder="Select Indicator"
                                        class="select__field"
                                        :disabled="
                                            disabledForm.indicators || isUpdate
                                        "
                                    >
                                        <el-option
                                            v-for="item in indicatorsList"
                                            :key="item.indicatorCode"
                                            :label="
                                                item.indicatorCode +
                                                ` - ` +
                                                item.indicator
                                            "
                                            :value="item.id"
                                            :disabled="item.disabled"
                                        >
                                        </el-option>
                                    </el-select>
                                </div>
                            </td> -->
                            
                            <td>
                                <div class="input">
                                    Target Value :
                                    <el-input
                                        v-model="indicatorForm.Target_value"
                                        placeholder="Target Value"
                                        class="input__field"
                                        :disabled="disabledForm.metrics"
                                    ></el-input>
                                </div>
                            </td>
                            <td>
                                <div class="input">
                                    Target Metric :
                                    <el-select
                                        v-model="indicatorForm.Target_metric"
                                        placeholder="Target Metric"
                                        class="select__field filter-select mr-2"
                                        clearable
                                        :disabled="disabledForm.metrics"
                                    >
                                        <el-option
                                            v-for="item in targetMetricsList"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id"
                                        >
                                        </el-option>
                                    </el-select>
                                </div>
                            </td>
                            <td>
                                <div class="input">
                                    Target Year :
                                    <el-input
                                        v-model="indicatorForm.Target_year"
                                        placeholder="Target Year"
                                        class="input__field"
                                        :disabled="disabledForm.metrics"
                                    ></el-input>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div class="input">
                                    Mean Of Verification :
                                    <el-input
                                        v-model="
                                            indicatorForm.meanOfVerification
                                        "
                                        placeholder="Mean Of Verification"
                                        class="input__field"
                                        :disabled="disabledForm.metrics"
                                    ></el-input>
                                </div>
                            </td>

                            <td>
                                <div class="input">
                                    Final Value :
                                    <el-input
                                        v-model="indicatorForm.Final_value"
                                        placeholder="Final Value"
                                        class="input__field"
                                        :disabled="disabledForm.metrics"
                                    ></el-input>
                                </div>
                            </td>
                            <td>
                                <div class="input">
                                    Final Metric :
                                    <el-select
                                        v-model="indicatorForm.Final_metric"
                                        placeholder="Final Metric"
                                        class="select__field filter-select mr-2"
                                        clearable
                                        :disabled="disabledForm.metrics"
                                    >
                                        <el-option
                                            v-for="item in finalMetricsList"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id"
                                        >
                                        </el-option>
                                    </el-select>
                                </div>
                            </td>
                            <td>
                                <div class="input">
                                    Final Year :
                                    <el-input
                                        v-model="indicatorForm.Final_year"
                                        placeholder="Final Year"
                                        class="input__field"
                                        :disabled="disabledForm.metrics"
                                    ></el-input>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            
                            <td>
                                <div class="input">
                                    <base-button
                                        size="sm"
                                        type="primary"
                                        @click="openModal()"
                                        class="input__field addIndicatorBtn"
                                        style="width: 225px !important"
                                        v-if="
                                            !disabledForm.indicators &&
                                            !isUpdate
                                        "
                                        >Add Custom<i class="el-icon-plus"></i
                                    ></base-button>
                                </div>
                            </td>
                            <!-- <td>
                                <div class="input">
                                    Baseline value :
                                    <el-input
                                        v-model="indicatorForm.Baseline_value"
                                        placeholder="Baseline Value"
                                        class="input__field"
                                        :disabled="disabledForm.metrics"
                                    ></el-input>
                                </div>
                            </td>
                            <td>
                                <div class="input">
                                    Baseline Metric :
                                    <el-select
                                        v-model="indicatorForm.Baseline_metric"
                                        placeholder="Baseline Metric"
                                        class="select__field filter-select mr-2"
                                        clearable
                                        :disabled="disabledForm.metrics"
                                    >
                                        <el-option
                                            v-for="item in baselineMetricsList"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id"
                                        >
                                        </el-option>
                                    </el-select>
                                </div>
                            </td>
                            <td>
                                <div class="input">
                                    Baseline Year :
                                    <el-input
                                        v-model="indicatorForm.Baseline_year"
                                        placeholder="Baseline Year"
                                        class="input__field"
                                        :disabled="disabledForm.metrics"
                                    ></el-input>
                                </div>
                            </td> -->
                        </tr>
                    </table>
                </el-form>
            </div>
            <div class="indicatorsform__button">
                <div v-if="!isUpdate">
                    <base-button
                        size="sm"
                        type="primary"
                        @click="handleAdd(indicatorForm)"
                        class="indicatorsform__buttons"
                        ><i class="el-icon-check"></i>Add</base-button
                    >
                </div>
                <div v-if="isUpdate">
                    <base-button
                        size="sm"
                        type="primary"
                        @click="handleUpdate(indicatorForm)"
                        class="indicatorsform__buttons"
                        ><i class="el-icon-edit"></i>Update</base-button
                    >
                </div>
                <base-button
                    size="sm"
                    type="primary"
                    @click="handleClear()"
                    class="indicatorsform__buttons"
                    ><i class="el-icon-close"></i>Clear</base-button
                >
            </div>
            <br />
            <br />
        </div>
        <div class="errorAlert">{{ baseAlertText }}</div>

        <!-- <base-button @click="addIndicator()" v-if="!isUpdate"
            >Submit</base-button
        >
        <base-button @click="updateIndicator()" v-if="isUpdate"
            >Update</base-button
        > -->

        <div class="table">
            <el-table :data="tableData" style="width: 100%" class="table">
                <el-table-column
                    prop="indicator.indicator"
                    label="Indicator"
                    class="table__column"
                    sortable
                >
                </el-table-column>
                <!-- <el-table-column
                    prop="baselineValue"
                    label="Baseline Value"
                    class="table__column"
                    sortable
                >
                </el-table-column>

                <el-table-column
                    prop="baselinemetric.name"
                    label="Baseline Metric"
                    class="table__column"
                    sortable
                >
                </el-table-column
                ><el-table-column
                    prop="baselineYear"
                    label="Baseline Year"
                    class="table__column"
                    sortable
                >
                </el-table-column> -->
                <el-table-column
                    prop="targetValue"
                    label="Target Value"
                    class="table__column"
                    sortable
                >
                </el-table-column>
                <el-table-column
                    prop="targetmetric.name"
                    label="Target Metric"
                    class="table__column"
                    sortable
                >
                </el-table-column
                ><el-table-column
                    prop="targetYear"
                    label="Target Year"
                    class="table__column"
                    sortable
                >
                </el-table-column>
                <el-table-column
                    prop="finalValue"
                    label="Final Value"
                    class="table__column"
                    sortable
                >
                </el-table-column>
                <el-table-column
                    prop="finalmetric.name"
                    label="Final Metric"
                    class="table__column"
                    sortable
                >
                </el-table-column
                ><el-table-column
                    prop="finalYear"
                    label="Final Year"
                    class="table__column"
                    sortable
                >
                </el-table-column>

                <el-table-column
                    prop="meanOfVerification"
                    label="Mean Of Verification"
                    class="table__column"
                    sortable
                >
                </el-table-column>

                <!-- <el-table-column
                    prop="indicator"
                    label="Indicator"
                    class="table__column"
                    sortable
                >
                </el-table-column>
                <el-table-column
                    prop="Baseline_metric"
                    label="Baseline Metric"
                    class="table__column"
                    sortable
                >
                </el-table-column>
                <el-table-column
                    prop="Final_metric"
                    label="Final Metric"
                    class="table__column"
                    sortable
                >
                </el-table-column>
                <el-table-column
                    prop="Baseline_value"
                    label="Baseline Value"
                    class="table__column"
                    sortable
                >
                </el-table-column>
                <el-table-column
                    prop="Final_value"
                    label="Final Value"
                    class="table__column"
                    sortable
                >
                </el-table-column> -->
                <el-table-column label="" class="table__column">
                    <template slot-scope="scope">
                        <base-button
                            size="sm"
                            type="primary"
                            @click="handleEdit(scope.$index, scope.row)"
                            class="table__button"
                            :disabled="disabledindex == scope.$index"
                            >Edit<i class="el-icon-edit"></i
                        ></base-button>
                        <base-button
                            size="sm"
                            type="warning"
                            @click="handleDelete(scope.$index, scope.row)"
                            class="table__button"
                            >Delete<i class="el-icon-delete"></i
                        ></base-button>
                    </template> </el-table-column
                >̥
                <!-- <el-pagination layout="prev, pager, next" :total="this.tableData.length" @current-change="setPage">
  </el-pagination> -->
            </el-table>
            <!-- <base-button
                            size="sm"
                            type="info"
                            @click="handleSubmit()"
                            class="table__button"
                            >Submit</base-button> -->
        </div>
    </div>
</template>
<style lang="scss">
.el-autocomplete-suggestion.el-popper.my-autocomplete {
    width: 800px !important;
}
</style>
<style scoped lang="scss">
.indicatorsform {
    display: flex;
    flex-wrap: wrap;
    padding: 30px;
    background-color: white;
    // border:1px solid black;
    border-radius: 10px;
    box-shadow: inset;
    justify-content: flex-start;
    align-items: center;
    margin: 10px;

    // &__add {
    //     display: flex;

    //     justify-content: flex-end !important;
    // }
    &__button {
        // border:1px solid black;

        display: flex;
        flex-direction: row;
        padding: 10px;
        justify-content: flex-start;
        align-items: center;

        // max-height:30px;
    }
    &__buttons {
        display: flex;
        min-width: 50px;
        max-height: 30px;
        padding: 20px;
        // border:1px solid black;
    }
    .form2 {
        justify-content: flex-end;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        max-width: 800px;
        .input {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: flex-start;
            padding: 10px 20px;

            &__field {
                // max-width: 35vw;
            }
        }
        .select {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: flex-start;
            padding: 10px;
            &__field {
                max-width: 30vw;
                border-color: 1px solid;
            }
        }
    }
}
.addIndicatorWrapper {
    padding: 20px;
    width: 100%;
    display: flex;
    justify-content: flex-end;
    .addIndicatorBtn {
        transform: translateY(-3px);
        color: #90c14f;
        background: #f5f6fa !important;
    }
}

.table {
    margin-top: 10px;
    &__button {
        margin: 20px !important;
    }
    &__column {
        text-align: center !important;
    }
}
.addIndicatorBtn {
    transform: translateY(-3px);
}
.alert {
    min-height: 25vh;
    color: rgba(34, 42, 66, 0.7);
    padding: 30px;
    &__button {
        margin: 10px;
        margin-left: auto;
    }
}

.form {
    //     display: grid;
    // grid-template-columns: repeat(3, 1fr);
    // grid-template-rows: repeat(3, 1fr);
    // grid-column-gap: 0px;
    // grid-row-gap: 0px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;
    // gap:5;
    .input {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        padding: 10px;

        &__field {
            // max-width: 30vw;
        }
    }
    .select {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        padding: 10px;
        &__field {
            max-width: 30vw;
            border-color: 1px solid;
        }
    }
}
.errorAlert {
    color: red;
    margin-left: 10px;
}
// .btn:not(:disabled):not(.disabled) {
//     margin: 10px;
// }
</style>
<script>
import {
    LogMonitoringService,
    GrantService,
    ApplicationService,
    CallService,
} from "@/services";
import { Table, TableColumn, Select, Option, Autocomplete } from "element-ui";
import { Modal } from "src/components";
export default {
    name: "indicator-form",
    components: {
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        Modal,
        [Select.name]: Select,
        [Option.name]: Option,
        [Autocomplete.name]: Autocomplete,
        // Pagination
    },
    data() {
        return {
            showForm: false,
            showAlert: false,
            deleteID: "",
            isUpdate: false,
            tableData: [],
            submitData: [],
            page: 1,
            indicatorsList: [],
            addedIndicatorsList: [],
            baselineMetricsList: [],
            finalMetricsList: [],
            targetMetricsList: [],
            indicatorTypes: [],
            newIndicatorData: {},
            grantsList: [],
            applicationsList: [],
            countriesList: [],
            regionsList: [],
            metricsList: [],
            region: [],
            region_id: "",
            country_id: "",
            baseAlertText: "",
            baseAlertCustomText: "",
            disabledindex: -1,
            selectedIndicator: "",
            // yearRegex: /^(19|20)\d{2}$/,
            // yearRegex: /^(19|20)\d{2}$|^$/,
            // yearRegex: /^(19|20)\d{2}$|^$|^undefined$/,
            yearRegex: /^(19|20)\d{2}$|^$|^undefined$|^null$/,
            customIndicatorForm: {
                indicator_type: "",
                indicator_id: "",
                indicator_name: "",
                metric: "",
                description: "",
            },
            form: {
                Grant_ID: "1",
                // ISO3(or country long name):"",
                ISO3: "",
                Country: "",
                Region: "",
                Indicator_ID: "",
                Indicator_name: "",
                Baseline_value: "",
                Baseline_metric: "",
                Final_value: "",
                Final_metric: "",
                Target_value: "",
                Target_metric: "",
                Target_value: "",
                Application: "",
                WDPaid: "",
            },
            indicatorForm: {
                indicator: "",
                Baseline_value: "",
                Baseline_metric: "",
                Baseline_year: "",
                Final_value: "",
                Final_metric: "",
                Final_year: "",
                Target_value: "",
                Target_metric: "",
                Target_year: "",
                custom: 0,
                final_metric_id: "",
                baseline_metric_id: "",
                target_metric_id: "",
                application_indicator_id: "",
                meanOfVerification: "",
            },
            disabledForm: {
                applications: true,
                indicators: true,
                metrics: true,
            },
        };
    },
    methods: {
        // For Autocomplete
        querySearch(queryString, cb) {
            //     var k= [
            //   { "value": "vue", "link": "https://github.com/vuejs/vue" },
            //   { "value": "element", "link": "https://github.com/ElemeFE/element" },
            //   { "value": "cooking", "link": "https://github.com/ElemeFE/cooking" },
            //   { "value": "mint-ui", "link": "https://github.com/ElemeFE/mint-ui" },
            //   { "value": "vuex", "link": "https://github.com/vuejs/vuex" },
            //   { "value": "vue-router", "link": "https://github.com/vuejs/vue-router" },
            //   { "value": "babel", "link": "https://github.com/babel/babel" }
            //  ];
            //  var links =k;
            // var links = this.indicatorsList.map((i) => i.indicator);
            var links = this.indicatorsList.filter((item) => {
                if (item.disabled != true) {
                    return item;
                }
            });
            if (queryString == "") {
                this.indicatorForm.indicator = "";
            }
            var results = queryString
                ? links.filter(this.createFilter(queryString))
                : links;
            // call callback function to return suggestions
            cb(results);
            // return results;
        },
        createFilter(queryString) {
            return (link) => {
                return (
                    link.indicator
                        .toLowerCase()
                        .indexOf(queryString.toLowerCase()) === 0
                );
            };
        },
        handleSelect(item) {
            console.log(item);
            // const selectedIndicator = this.indicatorsList.find(
            //     (indicator) => indicator.indicator === item
            // );
            // this.indicatorForm.indicator = selectedIndicator.id;
            this.indicatorForm.indicator = item.id;
            // this.selectedIndicator = item.indicatorCode + " - " + item.indicator;
            this.selectedIndicator = item.indicator;
        },
        //   Autocomplete finished
        setPage(val) {
            this.page = val;
        },
        onSubmit() {},
        async handleUpdate(data) {
            var temp_tableData = {};
            // if (
            //     this.indicatorForm.indicator == "" ||
            //     this.indicatorForm.Baseline_value == "" ||
            //     this.indicatorForm.Baseline_metric == "" ||
            //     this.indicatorForm.Final_metric == "" ||
            //     this.indicatorForm.Final_value == "" ||
            //     this.indicatorForm.Target_metric == "" ||
            //     this.indicatorForm.Target_value == "" ||
            //     this.indicatorForm.Baseline_year == "" ||
            //     this.indicatorForm.Final_year == "" ||
            //     this.indicatorForm.Target_year == ""
            // ) {
            if (this.indicatorForm.indicator == "") {
                this.baseAlertText =
                    "Please input all fields before submission";
                return;
            } else if (
                !this.yearRegex.test(this.indicatorForm.Baseline_year) ||
                !this.yearRegex.test(this.indicatorForm.Final_year) ||
                !this.yearRegex.test(this.indicatorForm.Target_year)
            ) {
                if (
                    !this.yearRegex.test(this.indicatorForm.Baseline_year) &&
                    !this.yearRegex.test(this.indicatorForm.Final_year) &&
                    !this.yearRegex.test(this.indicatorForm.Target_year)
                ) {
                    this.baseAlertText =
                        "Make sure the inputs for the baseline year, the final year, and the target year are all valid years.";
                    return;
                } else {
                    if (
                        !this.yearRegex.test(this.indicatorForm.Baseline_year)
                    ) {
                        this.baseAlertText =
                            "Make sure the inputs for the baseline year is valid.";
                        return;
                    } else if (
                        !this.yearRegex.test(this.indicatorForm.Final_year)
                    ) {
                        this.baseAlertText =
                            "Make sure the inputs for the final year is valid.";
                        return;
                    } else if (
                        !this.yearRegex.test(this.indicatorForm.Target_year)
                    ) {
                        this.baseAlertText =
                            "Make sure the inputs for the target year is valid.";
                        return;
                    }
                }
            } else {
                this.baseAlertText = "";
            }
            temp_tableData = {
                indicator: this.indicatorForm.indicator,
                indicator_id: this.indicatorForm.indicator,
                // baseline_metric: data.Baseline_metric,
                // final_metric: data.Final_metric,
                baseline_value: this.indicatorForm.Baseline_value,
                final_value: this.indicatorForm.Final_value,
                target_value: this.indicatorForm.Target_value,
                grant_id: this.form.Grant_ID,
                application_id: this.form.Application,
                application_indicator_id:
                    this.indicatorForm.application_indicator_id,
                region_id: this.region_id,
                // country_id: this.country_id,
                country_id: this.form.Country,
                custom: data.custom,
                final_metric: this.indicatorForm.Final_metric,
                baseline_metric: this.indicatorForm.Baseline_metric,
                target_metric: this.indicatorForm.Target_metric,
                Baseline_year: this.indicatorForm.Baseline_year,
                Final_year: this.indicatorForm.Final_year,
                Target_year: this.indicatorForm.Target_year,
                meanOfVerification: this.indicatorForm.meanOfVerification,
                // final_metric_id: this.indicatorForm.final_metric_id,
                // baseline_metric_id: this.indicatorForm.baseline_metric_id,
                wdpaid: this.form.WDPaid,
            };

            await LogMonitoringService.updateApplicationIndicator(
                temp_tableData
            ).then((response) => {
                this.handleClear();
                this.getApplicationIndicators();
            });
        },
        openModal() {
            // this.getGrants();
            this.customIndicatorForm.indicator_id = "";
            this.customIndicatorForm.indicator_name = "";
            this.customIndicatorForm.metric = "";
            this.customIndicatorForm.description = "";
            this.customIndicatorForm.indicator_type = "";
            this.showForm = !this.showForm;
            this.isUpdate = false;
            this.baseAlertCustomText = "";
        },
        async getApplicationIndicators() {
            await LogMonitoringService.getApplicationIndicators({
                applicationId: this.form.Application,
            }).then((response) => {
                this.tableData = response.data.data;
                this.disableIndicators();
            });
            this.form.WDPaid = "";
            this.form.Region = "";
            this.region_id = "";
            this.form.Country = "";
            this.country_id = "";
            await LogMonitoringService.getApplicationDetails({
                applicationId: this.form.Application,
            }).then((response) => {
                this.form.WDPaid =
                    response.data.data.wdpaid == null
                        ? ""
                        : response.data.data.wdpaid.wdpaid;
                this.form.Region = response.data.data.region.name;
                this.region_id = response.data.data.region.regionId;
                this.countriesList = response.data.data.country;
                this.form.Country =
                    response.data.data.selectedCountry.countryId;
                // console.log("Countries : ",this.countriesList)
                // this.form.Country = response.data.data.country[0].name;
                // this.country_id = response.data.data.country[0].countryId;
            });
            this.disableIndicators();
        },
        async getIndicators() {
            await LogMonitoringService.getIndicators().then((response) => {
                this.indicatorsList = response.data.data.data;
                this.disableIndicators();
            });
        },
        async getIndicatorTypes() {
            await LogMonitoringService.getIndicatortypes().then((response) => {
                this.indicatorTypes = response.data.data;
            });
        },
        checkDuplicates(array) {
            var valuesSoFar = Object.create(null);
            for (var i = 0; i < array.length; ++i) {
                var value = array[i];
                if (value in valuesSoFar) {
                    return true;
                }
                valuesSoFar[value] = true;
            }
            return false;
        },
        async addIndicator() {
            var isIndicatorExist = false;

            // if (
            //     this.customIndicatorForm.indicator_type == "" ||
            //     this.customIndicatorForm.metric == "" ||
            //     this.customIndicatorForm.indicator_id == "" ||
            //     this.customIndicatorForm.indicator_name == ""
            // )
            if (
                this.customIndicatorForm.metric == "" ||
                this.customIndicatorForm.indicator_id == "" ||
                this.customIndicatorForm.indicator_name == ""
            ) {
                // console.log("No data");
                this.baseAlertCustomText =
                    "Please input all fields before submission";
                return;
            }
            const data = {
                indicator_id: this.customIndicatorForm.indicator_id,
                indicator: this.customIndicatorForm.indicator_name,
                indicator_type_id: this.customIndicatorForm.indicator_type,
                metric: this.customIndicatorForm.metric,
                description: this.customIndicatorForm.description,
            };
            const customData = {
                indicator_code: this.customIndicatorForm.indicator_id,
                indicator: this.customIndicatorForm.indicator_name,
                indicator_type_id: this.customIndicatorForm.indicator_type,
                metric: this.customIndicatorForm.metric,
                description: this.customIndicatorForm.description,
                custom: 1,
            };
            this.indicatorsList.forEach((item) => {
                if (
                    item.indicatorCode === data.indicator_id &&
                    !isIndicatorExist
                ) {
                    // debugger;
                    this.baseAlertCustomText = "Indicator ID already exists";
                    isIndicatorExist = true;
                    return;
                }
            });
            // From master form
            await LogMonitoringService.addIndicator(customData)
                .catch((response) => {
                    this.baseAlertCustomText =
                        "The indicator ID has already been taken.";
                    // this.showBaseAlert = true;
                    // alert(this.baseAlertText);
                })
                .then((response) => {
                    console.log(response);
                    if (response.error) {
                        this.baseAlertCustomText = response.error;
                        // this.showBaseAlert = true;
                    } else {
                        // console.log("Respose : ",response);
                        this.customIndicatorForm.indicator_id =
                            response.data.data.id;
                    }
                });

            this.newIndicatorData = data;

            // this.indicatorForm.Baseline_metric =
            //     this.newIndicatorData.metric;
            // this.indicatorForm.Final_metric = this.newIndicatorData.metric;
            //For metrics
            //     var metricList = this.newIndicatorData.metric.split(",");
            //     if (this.checkDuplicates(metricList) == true) {
            //         this.baseAlertCustomText = "Metrics can't have duplicates";
            //         isIndicatorExist = true;
            //         return;
            //     }
            //     this.baselineMetricsList = [];
            //     this.finalMetricsList = [];
            //     this.targetMetricsList = [];
            //     for (var i = 0; i < metricList.length; i++) {
            //         this.baselineMetricsList.push({
            //             id: metricList[i],
            //             name: metricList[i],
            //         });
            //         this.finalMetricsList.push({
            //             id: metricList[i],
            //             name: metricList[i],
            //         });
            //         this.targetMetricsList.push({
            //             id: metricList[i],
            //             name: metricList[i],
            //         });
            //     }
            if (!isIndicatorExist) {
                this.indicatorForm.custom = 1;
                this.indicatorForm.indicator = this.newIndicatorData.indicator;
                this.selectedIndicator =
                    this.customIndicatorForm.indicator_name;
                this.showForm = false;

                this.indicatorForm.Baseline_metric =
                    this.baselineMetricsList[0];
                this.indicatorForm.Final_metric = this.finalMetricsList[0];
                this.disabledForm.metrics = false;
            }
        },
        // async updateIndicator() {
        //     if (
        //         this.form.indicator_id == "" ||
        //         this.form.indicator_name == ""
        //     ) {
        //         console.log("No data");
        //         return;
        //     }
        //     const data = {
        //         id: this.form.id,
        //         indicator_id: this.form.indicator_id,
        //         indicator: this.form.indicator_name,
        //         indicator_type_id: this.form.indicator_type,
        //     };
        //     await LogMonitoringService.updateIndicator(data).then(
        //         (response) => {
        //             console.log(response);
        //             this.form.indicator_id = "";
        //             this.form.indicator_name = "";
        //             this.form.indicator_type = "";
        //             this.showForm = false;
        //             this.isUpdate = false;
        //             this.getIndicators();
        //             console.log("Updated indicator");
        //         }
        //     );
        // },
        async handleEdit(index, row) {
            for (const key in this.indicatorForm) {
                this.indicatorForm[key] = "";
            }
            // console.log("Index : ", index);
            this.getIndicators();
            // this.disabledindex = index;
            // this.indicatorForm.indicator = this.tableData[index].indicator;
            if (row.finalValue == null) {
                row.finalValue = row.finalTextValue;
            }
            if (row.baselineValue == null) {
                row.baselineValue = row.baselineTextValue;
            }
            if (row.targetValue == null) {
                row.targetValue = row.targetTextValue;
            }
            this.isUpdate = true;
            // This was not working
            //    this.indicatorForm.indicator = row.indicatorId;
            //     this.indicatorForm.Baseline_value = row.baselineValue;
            //     this.indicatorForm.Final_value = row.finalValue;
            //     this.indicatorForm.Target_value = row.targetValue;
            //     this.indicatorForm.Baseline_year = row.baselineYear;
            //     this.indicatorForm.Final_year = row.finalYear;
            //     this.indicatorForm.Target_year = row.targetYear;
            //     this.indicatorForm.final_metric_id = row.finalmetric.id;
            //     this.indicatorForm.baseline_metric_id = row.baselinemetric.id;
            //     this.indicatorForm.target_metric_id = row.targetmetric.id;
            //     this.indicatorForm.application_indicator_id = row.id;
            //     this.indicatorForm.Baseline_metric = row.baselinemetric.id;
            //     this.indicatorForm.Final_metric = row.finalmetric.id;
            //     this.indicatorForm.Target_metric = row.targetmetric.id;
            //     this.indicatorForm.meanOfVerification = row.meanOfVerification;

            // This is the alternative method
            // this.$set(this.indicatorForm, "indicator", row.indicatorId);
            // this.$set(this.indicatorForm, "Baseline_value", row.baselineValue);
            // this.$set(this.indicatorForm, "Final_value", row.finalValue);
            // this.$set(this.indicatorForm, "Target_value", row.targetValue);
            // this.$set(this.indicatorForm, "Baseline_year", row.baselineYear);
            // this.$set(this.indicatorForm, "Final_year", row.finalYear);
            // this.$set(this.indicatorForm, "Target_year", row.targetYear);
            // this.$set(this.indicatorForm, "application_indicator_id", row.id);
            // this.$set(
            //     this.indicatorForm,
            //     "final_metric_id",
            //     row.finalmetric.id
            // );
            // this.$set(
            //     this.indicatorForm,
            //     "baseline_metric_id",
            //     row.baselinemetric.id
            // );
            // this.$set(
            //     this.indicatorForm,
            //     "target_metric_id",
            //     row.targetmetric.id
            // );
            // this.$set(
            //     this.indicatorForm,
            //     "Baseline_metric",
            //     row.baselinemetric.id
            // );
            // this.$set(this.indicatorForm, "Final_metric", row.finalmetric.id);
            // this.$set(this.indicatorForm, "Target_metric", row.targetmetric.id);
            // this.$set(
            //     this.indicatorForm,
            //     "meanOfVerification",
            //     row.meanOfVerification
            // );
            // this.$set(this.form, "Country", row.countryId);
            if (row) {
                this.selectedIndicator = row.indicator.indicator || "";
                this.$set(
                    this.indicatorForm,
                    "indicator",
                    row.indicatorId || ""
                );
                this.$set(
                    this.indicatorForm,
                    "Baseline_value",
                    row.baselineValue || ""
                );
                this.$set(
                    this.indicatorForm,
                    "Final_value",
                    row.finalValue || ""
                );
                this.$set(
                    this.indicatorForm,
                    "Target_value",
                    row.targetValue || ""
                );
                this.$set(
                    this.indicatorForm,
                    "Baseline_year",
                    row.baselineYear || ""
                );
                this.$set(
                    this.indicatorForm,
                    "Final_year",
                    row.finalYear || ""
                );
                this.$set(
                    this.indicatorForm,
                    "Target_year",
                    row.targetYear || ""
                );
                this.$set(
                    this.indicatorForm,
                    "application_indicator_id",
                    row.id || ""
                );
                if (row.finalmetric) {
                    this.$set(
                        this.indicatorForm,
                        "final_metric_id",
                        row.finalmetric.id || ""
                    );
                }
                if (row.baselinemetric) {
                    this.$set(
                        this.indicatorForm,
                        "baseline_metric_id",
                        row.baselinemetric.id || ""
                    );
                    this.$set(
                        this.indicatorForm,
                        "Baseline_metric",
                        row.baselinemetric.id || ""
                    );
                }
                if (row.finalmetric) {
                    this.$set(
                        this.indicatorForm,
                        "Final_metric",
                        row.finalmetric.id || ""
                    );
                }
                if (row.targetmetric) {
                    this.$set(
                        this.indicatorForm,
                        "target_metric_id",
                        row.targetmetric.id || ""
                    );
                    this.$set(
                        this.indicatorForm,
                        "Target_metric",
                        row.targetmetric.id || ""
                    );
                }
                this.$set(
                    this.indicatorForm,
                    "meanOfVerification",
                    row.meanOfVerification || ""
                );
                this.$set(this.form, "Country", row.countryId || "");
            }
        },
        // async handleSubmit() {
        //     const data = {
        //         indicators: this.submitData,
        //         grant_id: this.form.Grant_ID,
        //         application_id: this.form.Application,
        //         region_id: this.region_id,
        //         country_id: this.country_id,
        //         // region_id:this.form.Region,
        //         // country_id:this.form.Country
        //     };
        //     await LogMonitoringService.addApplicationIndicator(data).then(
        //         (response) => {
        //             // console.log("Added applications : ", response);
        //         }
        //     );
        // },
        // async handleAdd(data) {
        //     console.log(data);
        //     var temp_tableData = {};
        //     if (this.indicatorForm.custom == 1) {
        //         temp_tableData = {
        //             indicator: this.indicatorForm.indicator,
        //             indicator_id: this.customIndicatorForm.indicator_id,
        //             Baseline_metric: data.Baseline_metric,
        //             Final_metric: data.Final_metric,
        //             Baseline_value: data.Baseline_value,
        //             Final_value: data.Final_value,
        //         };
        //         this.tableData.push(temp_tableData);
        //         this.handleClear();
        //         temp_tableData = {
        //             indicator_id: this.customIndicatorForm.indicator_id,
        //             indicator_type: this.customIndicatorForm.indicator_type,
        //             indicator: this.customIndicatorForm.indicator_name,
        //             Baseline_metric: data.Baseline_metric,
        //             Final_metric: data.Final_metric,
        //             Baseline_value: data.Baseline_value,
        //             Final_value: data.Final_value,
        //             custom: data.custom,
        //         };
        //         this.submitData.push(temp_tableData);
        //         this.indicatorForm.custom = 0;
        //     } else if (this.indicatorForm.custom == 0) {
        //         console.log("data.indicator : ",data);
        //         await LogMonitoringService.getIndicator(data.indicator).then(
        //             (response) => {
        //                 console.log(response);

        //                 temp_tableData = {
        //                     indicator_id: response.data.data.id,
        //                     indicator: response.data.data.indicator,
        //                     Baseline_metric: data.Baseline_metric,
        //                     Final_metric: data.Final_metric,
        //                     Baseline_value: data.Baseline_value,
        //                     Final_value: data.Final_value,
        //                 };
        //                 this.tableData.push(temp_tableData);
        //                 this.handleClear();
        //                 temp_tableData = {
        //                     indicator_id: response.data.data.id,
        //                     indicator: response.data.data.indicator,
        //                     Baseline_metric: data.Baseline_metric,
        //                     Final_metric: data.Final_metric,
        //                     Baseline_value: data.Baseline_value,
        //                     Final_value: data.Final_value,
        //                     custom: data.custom,
        //                 };
        //                 this.submitData.push(temp_tableData);
        //             }
        //         );
        //     }
        // },
        async handleAdd(data) {
            this.isUpdate = false;
            // if (
            //     this.indicatorForm.indicator == "" ||
            //     this.indicatorForm.Baseline_value == "" ||
            //     this.indicatorForm.Baseline_metric == "" ||
            //     this.indicatorForm.Final_metric == "" ||
            //     this.indicatorForm.Final_value == "" ||
            //     this.indicatorForm.Target_metric == "" ||
            //     this.indicatorForm.Target_value == "" ||
            //     this.indicatorForm.Baseline_year == "" ||
            //     this.indicatorForm.Final_year == "" ||
            //     this.indicatorForm.Target_year == ""

            // ) {
            if (this.indicatorForm.indicator == "") {
                this.baseAlertText = "Please select indicator";
                // this.baseAlertText =
                //     "Please input all fields before submission";
                return;
            } else if (
                !this.yearRegex.test(this.indicatorForm.Baseline_year) ||
                !this.yearRegex.test(this.indicatorForm.Final_year) ||
                !this.yearRegex.test(this.indicatorForm.Target_year)
            ) {
                if (
                    !this.yearRegex.test(this.indicatorForm.Baseline_year) &&
                    !this.yearRegex.test(this.indicatorForm.Final_year) &&
                    !this.yearRegex.test(this.indicatorForm.Target_year)
                ) {
                    this.baseAlertText =
                        "Make sure the inputs for the baseline year, the final year, and the target year are all valid years.";
                    return;
                } else {
                    if (
                        !this.yearRegex.test(this.indicatorForm.Baseline_year)
                    ) {
                        this.baseAlertText =
                            "Make sure the inputs for the baseline year is valid.";
                        return;
                    } else if (
                        !this.yearRegex.test(this.indicatorForm.Final_year)
                    ) {
                        this.baseAlertText =
                            "Make sure the inputs for the final year is valid.";
                        return;
                    } else if (
                        !this.yearRegex.test(this.indicatorForm.Target_year)
                    ) {
                        this.baseAlertText =
                            "Make sure the inputs for the target year is valid.";
                        return;
                    }
                }
            } else {
                this.baseAlertText = "";
            }
            var temp_tableData = {};
            // Uncomment when custom should be checked
            if (
                this.indicatorForm.custom != undefined &&
                this.indicatorForm.custom == 1
            ) {
                temp_tableData = {
                    indicator: this.customIndicatorForm.indicator_name,
                    indicator_id: this.customIndicatorForm.indicator_id,
                    indicator_code: this.customIndicatorForm.indicator_id,
                    indicator_type_id: this.customIndicatorForm.indicator_type,
                    Baseline_metric: data.Baseline_metric,
                    Final_metric: data.Final_metric,
                    Target_metric: this.indicatorForm.Target_metric,
                    Baseline_value: data.Baseline_value,
                    Final_value: data.Final_value,
                    Target_value: this.indicatorForm.Target_value,
                    Baseline_year: this.indicatorForm.Baseline_year,
                    Final_year: this.indicatorForm.Final_year,
                    Target_year: this.indicatorForm.Target_year,
                    meanOfVerification: this.indicatorForm.meanOfVerification,
                    grant_id: this.form.Grant_ID,
                    application_id: this.form.Application,
                    region_id: this.region_id,
                    // country_id: this.country_id,
                    country_id: this.form.Country,
                    // custom: this.indicatorForm.custom,
                    wdpaid: this.form.WDPaid,
                    metric: this.customIndicatorForm.metric,
                    description: this.customIndicatorForm.description,
                };
                await LogMonitoringService.addApplicationIndicator(
                    temp_tableData
                ).then((response) => {
                    this.handleClear();
                    this.getApplicationIndicators();
                });
                this.indicatorForm.custom = 0;
                // } else if (this.indicatorForm.custom == 0) {
            } else {
                temp_tableData = {
                    indicator_id: this.indicatorForm.indicator,
                    indicator_code: this.indicatorForm.indicator,
                    // indicator: this.indicatorForm.indicator,
                    Baseline_metric: data.Baseline_metric,
                    Final_metric: data.Final_metric,
                    Target_metric: this.indicatorForm.Target_metric,
                    Baseline_value: data.Baseline_value,
                    Final_value: data.Final_value,
                    Target_value: this.indicatorForm.Target_value,
                    Baseline_year: this.indicatorForm.Baseline_year,
                    Final_year: this.indicatorForm.Final_year,
                    Target_year: this.indicatorForm.Target_year,
                    meanOfVerification: this.indicatorForm.meanOfVerification,
                    grant_id: this.form.Grant_ID,
                    application_id: this.form.Application,
                    region_id: this.region_id,

                    // country_id: this.country_id,
                    country_id: this.form.Country,
                    custom: this.indicatorForm.custom,
                    // wdpaid: this.form.WDPaid,
                };
                await LogMonitoringService.addApplicationIndicator(
                    temp_tableData
                ).then((response) => {
                    this.addedIndicatorsList.push(this.indicatorForm.indicator);
                    this.handleClear();
                    this.getApplicationIndicators();
                });
                this.indicatorForm.custom = 0;
            }
            // this.getIndicators();
            this.disableIndicators();
        },
        handleClear() {
            const indicatorForm = {
                indicator: "",
                Baseline_value: "",
                Baseline_metric: "",
                Final_value: "",
                Final_metric: "",
            };
            this.indicatorForm = indicatorForm;
            this.disabledForm.metrics = true;
            this.disabledindex = -1;
            this.isUpdate = false;
            this.baseAlertText = "";
            this.selectedIndicator = "";
        },
        async handleDelete(index, row) {
            // console.log(row);
            this.deleteID = row.id;
            this.showAlert = true;
        },
        async deleteApplicationIndicator() {
            await LogMonitoringService.deleteApplicationIndicator({
                application_indicator_id: this.deleteID,
            }).then((response) => {
                var Index = this.addedIndicatorsList.indexOf(this.deleteID);
                this.addedIndicatorsList.splice(Index, 1);
                this.showAlert = false;
                this.getApplicationIndicators();
            });
        },
        async getGrants() {
            // await GrantService.all().then((response) => {
            await CallService.all().then((response) => {
                // console.log(response);
                this.grantsList = response.data;
                // console.log("GrantList : ",this.grantsList);
            });
            // await GrantService.getGrantRegions().then((response) => {
            //     // console.log("GrantService.getGrantRegions : ", response);
            //     // this.regionsList = response.data.data;
            //     // console.log("GrantList : ",this.grantsList);
            // });
        },
        disableIndicators() {
            //     for (var i = 0; i < this.indicatorsList.length; i++) {
            //         for (var j = 0; j < this.tableData.length; j++) {
            //             if (
            //                 this.indicatorsList[i].id ===
            //                 this.tableData[j].indicator.id
            //             ) {
            //                 this.indicatorsList[i].disabled = true;
            //             } else {
            //                 this.indicatorsList[i].disabled = false;
            //             }
            //         }
            //     }
            // },
            if (this.tableData.length == 0) {
                for (var j = 0; j < this.indicatorsList.length; j++) {
                    this.indicatorsList[j]["disabled"] = false;
                }
            }
            for (var i = 0; i < this.indicatorsList.length; i++) {
                for (var j = 0; j < this.tableData.length; j++) {
                    if (
                        this.indicatorsList[i].id !=
                        this.tableData[j].indicator.id
                    ) {
                        this.indicatorsList[i]["disabled"] = false;
                        // alert(`Inside disable button : ${this.indicatorsList[i].id}`)
                    }
                    // else {
                    //     // alert(`Inside Not disable button : ${this.indicatorsList[i].id}`)

                    //     this.indicatorsList[i]["disabled"] = false;
                    // }
                }
            }
            for (var i = 0; i < this.indicatorsList.length; i++) {
                for (var j = 0; j < this.tableData.length; j++) {
                    if (
                        this.indicatorsList[i].id ==
                        this.tableData[j].indicator.id
                    ) {
                        this.indicatorsList[i]["disabled"] = true;
                        // alert(`Inside disable button : ${this.indicatorsList[i].id}`)
                    }
                    // else {
                    //     // alert(`Inside Not disable button : ${this.indicatorsList[i].id}`)

                    //     this.indicatorsList[i]["disabled"] = false;
                    // }
                }
            }
        },
    },
    mounted() {
        this.getGrants();
        this.getIndicators();
        this.getIndicatorTypes();
        this.form.Grant_ID=1;
    },
    watch: {
        "form.Grant_ID": async function (val) {
            // console.log(val);
            await LogMonitoringService.getApplications({
                grantId: this.form.Grant_ID,
            }).then((response) => {
                this.applicationsList = response.data;
                this.disabledForm.applications = false;
                this.form.Application = "";
                // console.log(
                //     "ApplicationService.getApplications : ",
                //     this.applicationsList
                // );
            });
            this.disableIndicators();
            this.handleClear();
        },
        "form.Application": function (val) {
            // console.log(val);
            // console.log(this.applicationsList);
            // region_details.name
            var region;
            this.getApplicationIndicators();
            this.applicationsList.forEach((item) => {
                if (item.id === val) {
                    // region = item.region_details.name;
                    // this.form.Region = item.region_details.name;
                    // this.form.Country = item.countries[0].name;
                    // this.region_id = item.region_id;
                    // this.country_id = item.countries[0].country_id;
                    this.disabledForm.indicators = false;
                }
            });
            this.disableIndicators();
            this.handleClear();
        },
        "indicatorForm.indicator": async function (val) {
            // console.log(val);
            if (this.indicatorForm.indicator == "") {
                return;
            }
            if (!this.isUpdate) {
                this.$set(this.indicatorForm, "Baseline_year", "2019");
                this.$set(this.indicatorForm, "Final_year", "2023");
                this.$set(this.indicatorForm, "Target_year", "2023");
            }

            await LogMonitoringService.getIndicatormetric({
                indicator_id: this.indicatorForm.custom
                    ? this.customIndicatorForm.indicator_id
                    : this.indicatorForm.indicator,
            }).then((response) => {
                if (!this.isUpdate) {
                    this.indicatorForm.Final_metric = "";
                    this.indicatorForm.Baseline_metric = "";
                }
                this.metricsList = response.data.data;
                // if (this.indicatorForm.custom != 1) {
                this.baselineMetricsList = response.data.data;
                this.finalMetricsList = response.data.data;
                this.targetMetricsList = response.data.data;
                // }
                this.disabledForm.metrics = false;
            });
            // this.disableIndicators();
        },
        addedIndicatorsList: function (val) {
            for (var i = 0; i < this.indicatorsList.length; i++) {
                for (var j = 0; j < this.addedIndicatorsList.length; j++) {
                    if (
                        this.indicatorsList[i].id ===
                        this.addedIndicatorsList[j]
                    ) {
                        this.indicatorsList[i]["disabled"] = true;
                    } else {
                        this.indicatorsList[i]["disabled"] = false;
                    }
                }
            }
        },
        tableData: async function (val) {
            // this.getIndicators();

            for (var i = 0; i < this.tableData.length; i++) {
                if (this.tableData[i].finalValue == null) {
                    this.tableData[i].finalValue =
                        this.tableData[i].finalTextValue;
                }
                if (this.tableData[i].baselineValue == null) {
                    this.tableData[i].baselineValue =
                        this.tableData[i].baselineTextValue;
                }
                if (this.tableData[i].targetValue == null) {
                    this.tableData[i].targetValue =
                        this.tableData[i].targetTextValue;
                }
            }
            await this.getIndicators();
            setTimeout(this.disableIndicators(), 1000);
            // this.disableIndicators();
        },
    },
    // computed:{
    //     baselineData(baselineValue) {
    //         debugger;
    //   return baselineValue;
    // }
    // }
};
</script>
